import FooterIcon from "./FooterIcon";

export default FooterIcon;